"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.ListItemWrapper = exports.ListItemExtras = exports.ListItemBody = exports.List = void 0;
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const Badge_1 = require("../../atoms/Badge");
const Icon_1 = require("../../atoms/Icon");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "List");
/**
 * Component that renders styled lists.
 */
const List = ({ className, children, variant = "simple", withNumbers = false, scale }) => {
    // HACK allow for nulls to be passed - this allows some TOC items to be conditional
    const childrenArray = Array.isArray(children) ? children : [children];
    const cleanChildren = childrenArray.filter((n) => !!n);
    return (React.createElement("div", { "data-test": "list", className: css("", `-variant-${variant}`, `-scale-${scale}`, {
            className
        }) }, React.Children.map(cleanChildren, (item, i) => React.cloneElement(item, {
        itemNumber: withNumbers ? i + 1 : undefined
    }))));
};
exports.List = List;
const activeClassName = css("list_activeItem");
const ListItemBody = ({ children }) => (React.createElement("div", { "data-test": "list-item-content", className: css("item_content") }, children));
exports.ListItemBody = ListItemBody;
const ListItemExtras = ({ children }) => (React.createElement("div", { className: css("item_extras") }, children));
exports.ListItemExtras = ListItemExtras;
const ListItemWrapper = ({ isActive, className, to, children, onClick }) => {
    const classes = css("item", {
        "-active": isActive,
        "-clickable": !!onClick,
        className
    });
    if (to && env.webLinks)
        return (React.createElement("a", { href: to, className: classes, "data-test": "list-item" }, children));
    if (to) {
        return (React.createElement(react_router_dom_1.NavLink, { to: to, className: classes, activeClassName: activeClassName, "data-test": "list-item" }, children));
    }
    return (React.createElement("div", { className: classes, "data-test": "list-item", onClick: onClick }, children));
};
exports.ListItemWrapper = ListItemWrapper;
/**
 *  Renders a list item
 */
const ListItem = (_a) => {
    var { badge, badgeVariant, actions, children, itemNumber } = _a, rest = __rest(_a, ["badge", "badgeVariant", "actions", "children", "itemNumber"]);
    const listActions = actions || [];
    const hasBadge = !!badge;
    const hasActions = listActions.length > 0;
    const hasBadgeOrActions = hasBadge || hasActions;
    return (React.createElement(exports.ListItemWrapper, Object.assign({}, rest),
        itemNumber !== undefined && (React.createElement("div", { className: css("number") }, itemNumber)),
        React.createElement(exports.ListItemBody, null, children),
        hasBadgeOrActions && (React.createElement(exports.ListItemExtras, null,
            hasBadge && (React.createElement(Badge_1.Badge, { variant: badgeVariant, size: "sm" }, badge.toString())),
            listActions.map((a, i) => (React.createElement(Icon_1.Icon, { key: i, name: a.icon, onClick: a.onClick })))))));
};
exports.ListItem = ListItem;
//# sourceMappingURL=index.js.map